import GlassContainer from "@/shared/components/glasscontainer";
import icon from "@/assets/icons/settings_icon.svg";
import { useNavigate } from "react-router-dom";
import { Users } from "lucide-react";

export interface IntegrationsSidebarProps {
  totalIntegrations: number;
  configuredCount: number;
  unconfiguredCount: number;
  loading: boolean;
}

export function IntegrationsSidebar({
  totalIntegrations,
  configuredCount,
  unconfiguredCount,
  loading,
}: IntegrationsSidebarProps) {
  const navigate = useNavigate();

  return (
    <aside className="w-80 shrink-0 px-8 pb-20 flex flex-col items-center justify-start overflow-y-auto min-h-screen">
      <img src={icon} className="size-68" />
      <h1 className="text-2xl font-bold tracking-tight text-foreground mb-3 text-center">
        Integraciones
      </h1>
      <p className="text-sm text-foreground/50 leading-relaxed text-center">
        Conecta diferentes proveedores de autenticación para permitir que tus
        usuarios se registren e inicien sesión de múltiples formas.{" "}
      </p>
      <div className="mt-8 w-full space-y-3">
        <button
          onClick={() => navigate("/admin/integrations/access")}
          className="w-full group cursor-pointer flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl bg-white/60 border border-black/5 backdrop-blur-md hover:bg-accent hover:text-white hover:border-accent/20 transition-all duration-200 shadow-sm text-sm font-semibold text-foreground"
        >
          <Users className="size-4" />
          <span>Gestionar accesos</span>
        </button>

        <GlassContainer className="flex items-center justify-between p-4">
          <p className="text-xs font-semibold text-foreground/60 uppercase tracking-widest">
            Total
          </p>
          <p className="text-3xl font-bold text-foreground">
            {loading ? "—" : totalIntegrations}
          </p>
        </GlassContainer>
        <GlassContainer className="flex items-center justify-between p-4">
          <p className="text-xs font-semibold text-green-600 uppercase tracking-widest">
            Configurados
          </p>
          <p className="text-3xl font-bold text-green-600">
            {loading ? "—" : configuredCount}
          </p>
        </GlassContainer>
        <GlassContainer className="flex items-center justify-between p-4">
          <p className="text-xs font-semibold text-amber-600 uppercase tracking-widest">
            Sin configurar
          </p>
          <p className="text-3xl font-bold text-amber-600">
            {loading ? "—" : unconfiguredCount}
          </p>
        </GlassContainer>
      </div>
    </aside>
  );
}
